import { nanoid } from "nanoid";

export default {
  props: {
    id: {
      type: String,
      default: () => "input_" + nanoid(),
    },
  }
}